import { MAGAZINE_ISSUE_VIEW } from 'js/magazine-issue/View/View.queries'
import { FEED_ACTIVITIES } from 'js/page/Widget/components/Feed/FeedViewList.queries'
import { USER_ACTIVITY_TOTALS } from 'js/user/Activity/ActivityContainer'

export default [MAGAZINE_ISSUE_VIEW, USER_ACTIVITY_TOTALS, FEED_ACTIVITIES]
